import { HttpClient } from '@angular/common/http';
import { AccountService } from './account.service';
import { SCAMP_API } from 'src/environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { Security } from 'src/app/utils/security.util';
import { Router } from '@angular/router';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./account.service";
import * as i3 from "@angular/platform-browser";
import * as i4 from "@angular/router";
export class UsuarioService {
    constructor(http, account, sanitizer, router) {
        this.http = http;
        this.account = account;
        this.sanitizer = sanitizer;
        this.router = router;
    }
    getAutorizacoesJanelaPorRota(rota) {
        const autorizacoesUsuarioLogado = Security.getAutorizacoes();
        if (autorizacoesUsuarioLogado) {
            const autorizacoes = autorizacoesUsuarioLogado.filter(a => a.rota.toLowerCase() === rota.toLowerCase() && a.tipo === 1)[0];
            if (autorizacoes === undefined || autorizacoes == null) {
                this.router.navigate(['/not-authorized']);
            }
            else {
                if (autorizacoes.podeAcessar === false) {
                    this.router.navigate(['/not-authorized']);
                }
                else {
                    return autorizacoes;
                }
            }
        }
        else {
            return null;
        }
    }
    getAutorizacoesEspecificaPorRota(rota, especifica) {
        const autorizacoesUsuarioLogado = Security.getAutorizacoes();
        if (autorizacoesUsuarioLogado) {
            const autorizacoEspecifica = autorizacoesUsuarioLogado.filter(a => a.rota.toLowerCase() === rota.toLowerCase() &&
                a.tipo === 2 &&
                a.especifica === especifica)[0];
            if (autorizacoEspecifica != null || autorizacoEspecifica !== undefined) {
                return autorizacoEspecifica.estaAutorizado;
            }
            else {
                return false;
            }
        }
        else {
            return null;
        }
    }
    // Não usar mais
    getAutorizacoesPorClaim(rota) {
        const autorizacoesUsuarioLogado = Security.getAutorizacoes();
        if (autorizacoesUsuarioLogado) {
            return autorizacoesUsuarioLogado.filter(a => a.rota.toLowerCase() === rota.toLowerCase())[0];
        }
        else {
            return null;
        }
    }
    getAutorizacoesPorFuncionalidadeId(id) {
        const autorizacoesUsuarioLogado = Security.getAutorizacoes();
        if (autorizacoesUsuarioLogado) {
            return autorizacoesUsuarioLogado.filter(a => a.funcionalidadeId === id)[0];
        }
        else {
            return null;
        }
    }
    getUsuarioLogadoId() { return Security.getUser().id; }
    getUsuariosCadastrados() {
        return this.http.get(`${SCAMP_API.accountApiV1}/users-cadastrados`, { headers: this.account.composeHeaders() });
    }
    getUsuarioCadastradoPorNomeLogin(nomeLogin) {
        return this.http.get(`${SCAMP_API.accountApiV1}/usuarios/pornomelogin/${nomeLogin}`, { headers: this.account.composeHeaders() });
    }
    getUsuarioAutorizacoes(id) {
        return this.http.get(`${SCAMP_API.accountApiV1}/usuario-autorizacoes/${id}`, { headers: this.account.composeHeaders() });
    }
    getUsuarioCadastrado(id) {
        return this.http.get(`${SCAMP_API.accountApiV1}/user/${id}`, { headers: this.account.composeHeaders() });
    }
    getUsuariosCB() {
        return this.http.get(`${SCAMP_API.accountApiV1}/usuarios-cb/`, { headers: this.account.composeHeaders() });
    }
    getUsuario(id) {
        return this.http.get(`${SCAMP_API.accountApiV1}/usuario/${id}`, { headers: this.account.composeHeaders() });
    }
    registrar(data) {
        return this.http.post(`${SCAMP_API.accountApiV1}/usuario`, data, { headers: this.account.composeHeaders() });
    }
    editar(id, data) {
        return this.http.put(`${SCAMP_API.accountApiV1}/usuario/${id}`, data, { headers: this.account.composeHeaders() });
    }
    resertarSenha(id) {
        return this.http.put(`${SCAMP_API.accountApiV1}/usuario-resetar-senha/${id}`, '', { headers: this.account.composeHeaders() });
    }
    ativarDesativar(id) {
        return this.http.put(`${SCAMP_API.accountApiV1}/usuario-ativar-desativar/${id}`, '', { headers: this.account.composeHeaders() });
    }
    getSantizeUrl(fotoMimeType, foto) {
        const url = `data:${fotoMimeType};base64, ${foto}`;
        return this.sanitizer.bypassSecurityTrustUrl(url);
    }
    bypassSecurityTrustUrl(url) {
        return this.sanitizer.bypassSecurityTrustUrl(url);
    }
    getFotoUsuario(id) {
        return this.http.get(`${SCAMP_API.accountApiV1}/usuario-foto/${id}`, { headers: this.account.composeHeaders() });
    }
    alterarSenha(id, data) {
        return this.http.put(`${SCAMP_API.accountApiV1}/usuario-alterar-senha/${id}`, data, { headers: this.account.composeHeaders() });
    }
}
UsuarioService.ngInjectableDef = i0.defineInjectable({ factory: function UsuarioService_Factory() { return new UsuarioService(i0.inject(i1.HttpClient), i0.inject(i2.AccountService), i0.inject(i3.DomSanitizer), i0.inject(i4.Router)); }, token: UsuarioService, providedIn: "root" });
